import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Image, Form } from 'react-bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import './email-verify.css';

import logo2 from "../../../assets/images/logo2.png";
import backarrow from "../../../assets/images/backarrow.jpg";
import responsivebg from "../../../assets/images/responsive-bg.png";

import Stepper from '../Stepper';
import * as userActions from "../../../actions/user";

export const EmailVerify = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [existUser, setExistUser] = useState(false);
    const [confirmEmail, setConfirmEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const fetchUserEmail = async () => {
            try {
                const response = await userActions.getEmailDetail();
                if (response && response.email) {
                    setExistUser(true);
                    setEmail(response.email);
                    setConfirmEmail(response.email);
                }
            } catch (error) {
                console.error("Error fetching user images:", error);
            }
        };

        fetchUserEmail();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage('');

        // Basic validation
        if (!email || !email.includes('@')) {
            setErrorMessage('*Please enter a valid email address');
            return;
        }

        if (email !== confirmEmail) {
            setErrorMessage('*Email addresses do not match');
            return;
        }

        try {
            if (existUser) {
                navigate("/getstarted");
                return;
            } else {
                await userActions.updateEmail(JSON.stringify({
                    email: email
                }));
                navigate("/getstarted");
                setErrorMessage('');
            }
        } catch (error) {
            setErrorMessage(error.message || 'An error occurred. Please try again later.');
        }
    }

    return (
        <div className='emailverify-container'>
            <div className='emailverify-bg'>
                <Image className='responsive-bg' src={responsivebg}></Image>
            </div>
            <Container className='emailverify-main'>
                <Container className='emailverify-box'>
                    <Container className='logo-progressbar3'>
                        <Container className='logo-arrow3'>
                            <Image src={backarrow} className='backarrow' onClick={() => window.history.back()} />
                            <Image src={logo2} alt="Logo" className='logo' style={{ backgroundColor: 'transparent' }} />
                        </Container>
                        <Stepper activeStep="Email" />
                    </Container>
                    <Container><h3>Enter your email</h3></Container>
                    <Form onSubmit={handleSubmit} className='emailverify-form'>
                        <Container className='emailverify-content'>
                            <div style={{ width: '100%', alignItems: 'center' }}>
                                <Form.Group controlId="formCode" className='emailverify-form-group'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <Form.Label className='emailverify-lable'>Email</Form.Label>
                                            <Form.Control
                                                className={`emailverify-input ${errorMessage ? 'error' : ''}`}
                                                type="email"
                                                inputMode="email"
                                                value={email}
                                                autoCorrect="off"
                                                autoCapitalize="none"
                                                autoComplete="off"
                                                readOnly={existUser}
                                                placeholder="example@example.com"
                                                onChange={(e) => setEmail(e.target.value)}
                                                onPaste={(e) => e.preventDefault()}
                                            />
                                        </div>
                                        <div className='col-12 mt-3'>
                                            <Form.Label className='emailverify-lable'>Confirm email</Form.Label>
                                            <Form.Control
                                                className={`emailverify-input ${errorMessage ? 'error' : ''}`}
                                                type="text"
                                                inputMode="confirmEmail"
                                                value={confirmEmail}
                                                autoCorrect="off"
                                                autoCapitalize="none"
                                                autoComplete="off"
                                                readOnly={existUser}
                                                placeholder="example@example.com"
                                                onChange={(e) => setConfirmEmail(e.target.value)}
                                                onPaste={(e) => e.preventDefault()}
                                                onCopy={(e) => e.preventDefault()}
                                                onDragStart={(e) => e.preventDefault()}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ marginTop: "5px" }}>
                                        {errorMessage && <Form.Text className="text-danger error-message">{errorMessage}</Form.Text>}
                                    </div>
                                </Form.Group>
                            </div>

                            <button type="submit" className='global-next-btn'>
                                Next
                            </button>
                        </Container>
                    </Form>
                </Container>
            </Container>
        </div>
    );
}
